/* eslint-disable global-require */
/* eslint-disable import/extensions */
/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable import/no-mutable-exports */
/**
 * Copyright (c) 2021, Ouster, Inc.
 * All rights reserved.
 */
let store = require('./prod.tsx').default;

if (process.env.NODE_ENV === 'development') {
  store = require('./dev.tsx').default;
}

export default store;
